import React from 'react'

import { useUnit } from 'effector-react'

import { TwoFactorAwait } from 'components/_old/TwoFactorAwait/TwoFactorAwait'
import Width from 'components/_old/Width/Width'

import { goNext, showFailToastFx } from '../model'
import { TwoFactorSetupLayout } from '../TwoFactorSetupLayout'

const AwaitingPushStep = (): React.ReactElement => {
  const [handleShowFailToast, handleGoNext] = useUnit([showFailToastFx, goNext])

  return (
    <TwoFactorSetupLayout>
      <Width size={38} center>
        <TwoFactorAwait
          showTopBar={false}
          onAccept={handleGoNext}
          onDeny={handleShowFailToast}
          shouldVerifySms={false}
        />
      </Width>
    </TwoFactorSetupLayout>
  )
}

export { AwaitingPushStep }
